import { useEffect, useState } from 'react';
import { useAuthStore } from '@/store/authStore';

export function CallbackPage() {
  const handleCallback = useAuthStore((s) => s.handleCallback);
  const [err, setErr]  = useState<string | null>(null);

  useEffect(() => {
    handleCallback()
      .then(() => { window.location.replace('/'); })
      .catch((e: unknown) => setErr(e instanceof Error ? e.message : String(e)));
  }, [handleCallback]);

  return (
    <div className="h-dvh grid place-items-center bg-[var(--bg-base)] text-[var(--fg-primary)]">
      {err ? (
        <div className="text-center space-y-3 max-w-md px-6">
          <div className="text-[var(--accent-destructive)] font-medium">Sign-in failed</div>
          <div className="text-sm text-[var(--fg-muted)]">{err}</div>
          <button
            onClick={() => { localStorage.clear(); sessionStorage.clear(); window.location.replace('/'); }}
            className="px-4 py-2 rounded-md bg-[var(--accent-brand)] text-white text-sm"
          >
            Reset session
          </button>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-sm text-[var(--fg-muted)]">
          <span className="w-2 h-2 rounded-full bg-[var(--accent-brand)] animate-pulse" />
          completing sign-in…
        </div>
      )}
    </div>
  );
}
